import { onBeforeUnmount, onMounted, ref, watch } from 'vue-demi';

/** 头图 / 奖励模块按钮进入视口时隐藏吸底，避免同时出现。 */
export function useStickyVisibility(getTargets: () => (Element | null)[]) {
  const moduleCtaVisible = ref(false);
  let observer: IntersectionObserver | null = null;

  function refresh() {
    moduleCtaVisible.value = getTargets().some((el) => {
      if (!el) {
        return false;
      }
      const rect = el.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    });
  }

  function bind() {
    if (observer) {
      observer.disconnect();
    }
    observer = new IntersectionObserver(refresh, { threshold: 0.15 });
    getTargets().forEach((el) => {
      if (el && observer) {
        observer.observe(el);
      }
    });
    refresh();
  }

  onMounted(() => {
    bind();
    window.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
  });

  watch(
    getTargets,
    () => {
      bind();
    },
    { flush: 'post' },
  );

  onBeforeUnmount(() => {
    if (observer) {
      observer.disconnect();
    }
    window.removeEventListener('scroll', refresh);
    window.removeEventListener('resize', refresh);
  });

  return { moduleCtaVisible, rebind: bind };
}
